import { useContext } from 'react'
import DialogContext from 'services/Dialogs/context'
import { IDialogContext } from 'services/Dialogs/types'

export const useDialogs = (): IDialogContext => useContext(DialogContext)

export default useDialogs
